<!-- 地图 -->
<style lang="stylus" scoped>
.center {
  height: 786px;
  padding: 5px;
  background: url('../../../../static/img/dashboard/map-border.png');
  background-size: 100% 100%;
}
</style>

<template>
  <div>
    <div class="center">
      <centerTop></centerTop>
      <centerMap v-if="!child" :areaName="areaName" @clickMap="clickMap" @clickChild="clickChild"></centerMap>
      <centerBottom></centerBottom>
    </div>
  </div>
</template>

<script>
import centerTop from './centerTop';
import centerMap from './centerMap';
import centerChildMap from './centerChildMap';
import centerBottom from './centerBottom'

export default {
  props: {
    child: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      areaName: ''
    }
  },
  components: {
    centerTop,
    centerMap,
    centerChildMap,
    centerBottom
  },
  methods: {
    // 点击地图上的区域进入区域地图
    clickMap(areaName) {
      this.areaName = areaName;
      this.child = false
      this.$router.push(`/secondMap?areaName=${areaName}`);
    },
    // 判断是否点到子区域地图
    clickChild() {
      this.$emit('clickChild', true)
    }
  },
  mounted() {
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?761fa9a6